import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Route,
    // Redirect,
    NavLink
} from 'react-router-dom'
import {Icon, Label, Menu} from "semantic-ui-react";
import FAQPage from "./pages/faq";
import * as ReactGA from "react-ga";
import Footer from "./components/Footer";
// import logo from "./resources/images/logo.png"
import ContactPage from "./pages/contact";
import PageErrorBoundary from "./components/PageErrorBoundary";
import Homepage from "./pages/homepage";
import {connect} from "react-redux";
import InteractiveMapPage from "./pages/interactive-map";
import ListPage from "./homepage/ListPage";
import AdminPage from "./homepage/AdminPage";
import UnderConstruction from "./homepage/UnderConstruction";

// window.Raven.config('https://252a1de915f145dca8285a4df0d43c53@sentry.io/290963').install();

const RouteWithErrorBoundary = (props) => <PageErrorBoundary>
    <Route {...props} />
</PageErrorBoundary>;

export default class App extends Component {

    static logPageView () {
        window.scrollTo(0, 0);
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location.pathname);
        return null;
    };

    render() {
        return <Router>

            <div className="fullHeight">

                <Route component={App.logPageView} />

                {/*<Menu fixed="top">*/}
                    {/*<Menu.Item as={NavLink} to="/" exact header className="home">*/}
                        {/*/!*<img src={} alt="Green Tickets" className="logo"/>*!/*/}
                        {/*<h1>SailScanner</h1>*/}
                    {/*</Menu.Item>*/}

                    {/*<Menu.Menu position='right'>*/}
                        {/*<Menu.Item as={NavLink} to="/" exact name='home'/>*/}
                        {/*/!*<Menu.Item as={NavLink} to="/travel-tips" name='travel tips'/>*!/*/}
                        {/*/!*<Menu.Item as={NavLink} to="/about" name='our story'/>*!/*/}
                        {/*/!*<Menu.Item as={NavLink} to="/roadmap" name='roadmap'/>*!/*/}
                        {/*<Menu.Item as={NavLink} to="/contact" name='contact'/>*/}
                    {/*</Menu.Menu>*/}
                {/*</Menu>*/}
                {/*<div className="stripes"/>*/}

                {/*<RouteWithErrorBoundary exact path="/" component={UnderConstruction}/>*/}
                <RouteWithErrorBoundary exact path="/" component={Homepage}/>
                {/*<RouteWithErrorBoundary exact path="/about" component={AboutPage}/>*/}
                <RouteWithErrorBoundary exact path="/list" component={ListPage}/>
                <RouteWithErrorBoundary exact path="/map" component={InteractiveMapPage}/>
                <RouteWithErrorBoundary exact path="/contact" component={ContactPage}/>
                <RouteWithErrorBoundary exact path="/faq" component={FAQPage}/>

                <RouteWithErrorBoundary exact path="/admin" component={AdminPage}/>

                {/*<Footer/>*/}
            </div>
        </Router>
            ;
    }
}


// WEBPACK FOOTER //
// ./src/App.js